import Swal from 'sweetalert2';
import { deleteCookie, logout, virtualPath } from './EnvConfig';

export const NotificationSound = (status = '', message = '', focus = '', inputrefs = null, handleClear = null, toast = true) => {

    const obj_status = {
        'ERROR': {
            position: "center",
            icon: 'error',
            title: 'Oops..',
            color: '#dc362e'
        },
        'UNAUTHORIZED': {
            icon: 'error',
            title: 'Error',
            color: '#dc362e'
        },
        'SUCCESS': {
            icon: 'success',
            title: 'Success',
            color: '#238914'
        },
        'INFO': {
            icon: 'info',
            title: 'Information',
            color: '#2b6274'
        }
    };

    let customeMessage = status.trim().toUpperCase() === 'EXPIRED' ? "Session has expired, You are being redirected to Login page" : message;

    let _toast = toast;
    let timer = 0;
    let width = 500;

    const { icon, title, color } = obj_status[status.toUpperCase()] || obj_status.ERROR;

    if (_toast) {
        timer = 3000;
        width = 450;
    }
    const options = {
        position: !_toast ? 'center' : "top-end",
        toast: _toast,
        text: customeMessage || title,
        icon,
        title: (_toast ? null : title),
        color,
        confirmButtonColor: color,
        timerProgressBar: _toast,
        showConfirmButton: !_toast,
        iconColor: color,
        timer: timer,
        width: width,
        didOpen: (toast) => {
            if (_toast) {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
                if (status.trim().toUpperCase() === 'SUCCESS') {
                    if (handleClear !== null && inputrefs !== null) {
                        handleClear()
                    }
                }
                if (focus !== '' && inputrefs !== null && inputrefs !== undefined && inputrefs.current && inputrefs.current[focus] !== undefined && inputrefs.current[focus]) {
                    inputrefs.current[focus].focus();
                }
            }
        },
        didClose: () => {
            if (!_toast) {
                if (status.trim().toUpperCase() === 'SUCCESS') {
                    if (handleClear !== null && inputrefs !== null) {
                        handleClear()
                    }
                }
                if (focus !== '' && inputrefs !== null && inputrefs !== undefined && inputrefs.current && inputrefs.current[focus] !== undefined && inputrefs.current[focus]) {
                    inputrefs.current[focus].focus();
                }
            }
            if (status.trim().toUpperCase() === 'EXPIRED') {
                (async () => {
                    await deleteCookie('user');
                    await logout();
                    window.location.href = virtualPath + '/';
                })()
            }
        },
        showClass: {
            popup: 'animate__animated animate__fadeInUp animate__faster',
        },
        hideClass: {
            popup: 'animate__animated animate__fadeOutDown animate__faster',
        },
    };

    Swal.fire(options).then((result) => {
        if (result.isConfirmed) {
            if (status.trim().toUpperCase() === 'SUCCESS') {
                if (handleClear !== null && inputrefs !== null) {
                    handleClear()
                }
            }
            if (focus !== '' && inputrefs !== null && inputrefs !== undefined && inputrefs.current && inputrefs.current[focus] !== undefined && inputrefs.current[focus]) {
                inputrefs.current[focus].focus();
            }
        }
    });

    return;
}